import { render, staticRenderFns } from "./contactTable.vue?vue&type=template&id=21ac0dd8&scoped=true"
import script from "./contactTable.vue?vue&type=script&lang=ts"
export * from "./contactTable.vue?vue&type=script&lang=ts"
import style0 from "./contactTable.vue?vue&type=style&index=0&id=21ac0dd8&prod&lang=scss"
import style1 from "./contactTable.vue?vue&type=style&index=1&id=21ac0dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac0dd8",
  null
  
)

export default component.exports